// extracted by mini-css-extract-plugin
export default {"navbar":"ProtectedRoutes_navbar__xZFqk","navbarMain":"ProtectedRoutes_navbarMain__T923o","link":"ProtectedRoutes_link__vNvgr","AppShellMain":"ProtectedRoutes_AppShellMain__xIbEc"};